
export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      details: '(949) 951-8119',
      subtext: 'Mon-Fri 9AM-5PM'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      details: 'info@theinsurancedoctors.com',
      subtext: '24/7 Support'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Our Office',
      details: '13844 Alton Pkwy Suite 132',
      subtext: 'Irvine, CA 92618'
    }
  ];

  return (
    <section className="py-20 bg-white/95 backdrop-blur-sm" id="contact">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in-up opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Schedule Your Appointment
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready for your insurance checkup? Contact The Insurance Doctors today and let us prescribe the perfect coverage for your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="animate-fade-in-left opacity-0">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Get in Touch</h3>
            
            <div className="space-y-6 mb-8">
              {contactInfo.map((info, index) => (
                <div 
                  key={index}
                  className="flex items-start p-6 bg-gray-50/90 backdrop-blur-sm rounded-xl hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-200/50"
                >
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 hover:bg-blue-600 hover:scale-110 transition-all duration-300 group">
                    <i className={`${info.icon} text-2xl text-blue-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">{info.title}</h3>
                    <p className="text-lg text-blue-600 font-medium">{info.details}</p>
                    <p className="text-gray-600">{info.subtext}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-blue-50/90 backdrop-blur-sm rounded-xl p-6 border border-blue-200/50">
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Office Hours</h4>
              <div className="space-y-2 text-gray-600">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span className="font-medium">9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>After Hours</span>
                  <span className="font-medium">On Call</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday - Sunday</span>
                  <span className="font-medium">By Appointment</span>
                </div>
              </div>
            </div>
          </div>

          <div className="animate-fade-in-right opacity-0">
            <form className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 border border-white/20" id="contact-form">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Request Consultation</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="firstName">
                    First Name *
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="lastName">
                    Last Name *
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="email">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="john@example.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="phone">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="(555) 123-4567"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="insuranceType">
                  Insurance Type *
                </label>
                <div className="relative">
                  <button
                    type="button"
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white cursor-pointer"
                    onClick={(e) => {
                      const dropdown = e.currentTarget.nextElementSibling;
                      dropdown?.classList.toggle('hidden');
                    }}
                  >
                    <span id="selected-insurance">Select Insurance Type</span>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  </button>
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg hidden">
                    {['Auto Insurance', 'Home Insurance', 'Life Insurance', 'Business Insurance', 'Health Insurance', 'Multiple Types'].map((type) => (
                      <button
                        key={type}
                        type="button"
                        className="w-full px-4 py-2 text-left hover:bg-blue-50 transition-colors duration-200 cursor-pointer"
                        onClick={(e) => {
                          document.getElementById('selected-insurance')!.textContent = type;
                          (document.getElementById('insuranceTypeHidden') as HTMLInputElement).value = type;
                          e.currentTarget.parentElement?.classList.add('hidden');
                        }}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                  <input type="hidden" id="insuranceTypeHidden" name="insuranceType" required />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="message">
                  Tell us about your insurance needs *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  required
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none"
                  placeholder="Describe your current situation and what type of coverage you're looking for..."
                ></textarea>
                <p className="text-sm text-gray-500 mt-1">Maximum 500 characters</p>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget.closest('form') as HTMLFormElement;
                  if (form.checkValidity()) {
                    alert('Thank you for your request! We will contact you within 24 hours to schedule your consultation.');
                    form.reset();
                    document.getElementById('selected-insurance')!.textContent = 'Select Insurance Type';
                  } else {
                    form.reportValidity();
                  }
                }}
              >
                Schedule My Consultation
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
